import { gql } from "@/__generated__/gql";

export const UPDATE_ACTION_STATUS = gql(`
  mutation UpdateActionStatus(
    $riseActionId: ID!
    $status: RiseUserActionStudentStatusEnum!

  ) {
    bulkUpdateRiseUserActionStudentStatusMutation(input: {
      argument: {
        updateAll: {
          riseUserActionId: $riseActionId
          status: $status
        }
      }
    }) {
      clientMutationId
      errors {
        title
        message
      }
    }
  }
  `);
